import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import { RouterProvider } from 'react-router-dom'
import router from './router'
import { Provider } from 'react-redux'
import store from './store'
import 'normalize.css'
import IdleTimer from './IdleTimer';

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(

  <Provider store={store}>
    <IdleTimer />
    <RouterProvider router={router} />
  </Provider>

)


